import { Button, ButtonGroup } from "@mui/material";
import { FC } from "react";
import { Option } from "../interface/interface";

interface Props {
  variant: "contained" | "text" | "outlined";
  buttons: Option[];
  size?: "small" | "medium" | "large";
}

export const GroupedButton: FC<Props> = ({
  variant,
  buttons,
  size = "medium",
}) => {
  return (
    <ButtonGroup
      variant={variant}
      size={size}
      aria-label="grouped button"
      sx={{
        borderRadius: 20,
        overflow: "hidden",
      }}
    >
      {buttons.map((el, index) => (
        <Button
          key={`${el.label}_${index}`}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            minWidth: 64,
            px: 2,
          }}
        >
          {el.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
